import {useState} from 'react';
import {rebookBooking} from '../services/bookingServices';
import {useUserClaims} from '../hooks/useUserClaims';
import {DisplayMessage} from '../lib/interfaces';
import {DisplayMessageTypes, RoutePath} from '../lib/enums';
import {t} from 'i18next';
import {Trans} from 'react-i18next';
import {UPPSALA_KOMMUN_PHONE_NUMBER, investigationOfImpedimentsLink} from '../utils/constants';
import {getTranslatedErrorMessage} from '../helpers';
import {Link, useNavigate} from 'react-router-dom';
import {UaButton, UaLink} from 'uppsala.ui.react';

interface HandleRebookButtonProps {
  bookingId?: string;
  targetWeddingOccasionId?: string;
  onResult: (result: DisplayMessage) => void;
}

export const HandleRebookButton = (props: HandleRebookButtonProps) => {
  const navigate = useNavigate();

  const {userClaims} = useUserClaims();
  const [loading, setLoading] = useState(false);
  const [hideRebookButton, setHideRebookButton] = useState(false);

  const handleRebook = async () => {
    if (loading || !props.bookingId || !props.targetWeddingOccasionId) return;
    setLoading(true);
    const result = await rebookBooking(props.bookingId, props.targetWeddingOccasionId, userClaims?.['pinUserClaim']);

    setTimeout(() => {
      if (result.data) {
        setHideRebookButton(true);
        props.onResult({
          type: DisplayMessageTypes.Success,
          message: (
            <div>
              <p style={{marginBottom: '15px'}}>{t('booking.rebookingCompleted')}</p>{' '}
              <Link to={RoutePath.MyPages}>{t('booking.visitMyBookings')}</Link>
              <div style={{marginTop: '1rem'}}>
                <p>{t('booking.updateInvestigationOfImpedimentsInfo')}</p>
                <UaLink
                  text={t('booking.uploadInvestigationOfImpediments')}
                  link={investigationOfImpedimentsLink}
                  target="_blank"
                />
              </div>
            </div>
          ),
        } as DisplayMessage);
      } else {
        setHideRebookButton(result.info?.message !== 'INTERNAL_ERROR');
        props.onResult({
          type: result.info?.type,
          message: (
            <p className="whitespace-pre-line">
              <Trans
                i18nKey={getTranslatedErrorMessage(result.info?.message as string)}
                values={{number: UPPSALA_KOMMUN_PHONE_NUMBER}}
                components={{
                  1: <a href={`tel:${UPPSALA_KOMMUN_PHONE_NUMBER}`} aria-label="Telefonnummer" />,
                }}
              />
            </p>
          ),
        } as DisplayMessage);
      }
      setLoading(false);
    }, 1000);
  };

  if (!props.bookingId && !props.targetWeddingOccasionId) return <></>;

  if (hideRebookButton) {
    return <UaButton  type="primary" onClick={() => navigate(-1)} title={t('button.back')} />;
  }

  return (
    <>
      <UaButton onClick={() => navigate(-1)} title={t('button.cancel')} />
      <UaButton type="primary" title={'Byt tid'} loading={loading} onClick={handleRebook} />
    </>
  );
};
